<template>
  <div>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link">
        <component :is="require('icons/Translate').default" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="locale in Object.keys($i18n.messages)"
          :key="locale"
          @click.native="handleChangeLocale(locale)"
          >{{ locale.toUpperCase() }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "language_toggler",
  methods: {
    handleChangeLocale(locale) {
      this.$store.commit("user/setLocale", locale);
    }
  },
  computed: {
    ...mapGetters({
      locale: "locale",
      settings: "user/getSettings"
    }),
    user() {
      return this.$store.state.user.user;
    }
  }
};
</script>

<style scoped lang="stylus">
.el-dropdown {
    font-size: 24px;
}
.el-dropdown-link {
    cursor: pointer;
}
.el-dropdown-menu.el-popper {
    margin: -8px 0 0 8px;
}
</style>
